import "./TaskPanelTop.css";

import { ClosePanelArrowRightBlueIcon, TrashDark } from "../../../../assets";
import { SearchWorkflowTasksResponse } from "../../../../service/query";
import { Button } from "../../../../widget";

export interface TaskPanelTopProps {
  handleCloseTaskPanel: () => void;
  handleClickDeleteTask: () => void;
  hasFullEditAccess: boolean;
  task: SearchWorkflowTasksResponse["results"][0] | undefined;
}

export const TaskPanelTop = ({
  handleCloseTaskPanel,
  handleClickDeleteTask,
  hasFullEditAccess,
  task,
}: TaskPanelTopProps): JSX.Element => {
  return (
    <div className="TaskPanelTop">
      <Button
        text="Close panel"
        icon={<ClosePanelArrowRightBlueIcon className="CloseIcon" />}
        variant="secondary"
        onClick={handleCloseTaskPanel}
        minWidth={false}
        hasNoPadding
      />
      {hasFullEditAccess && task && (
        <Button
          text=""
          icon={<TrashDark className="TrashIcon" />}
          variant="secondary"
          onClick={handleClickDeleteTask}
          minWidth={false}
          hasNoPadding
        />
      )}
    </div>
  );
};
